export default __webpack_public_path__ + "static/media/twitterIcon.4331f110.svg";